<template>
  <div id="sovdetail">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  			<div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  	 		<div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
          	<option value="https://www.amazon.com">Amazon</option>
          </select>
        </div>
        <div class="datebox" style="width:18%">
          <select  class="form-control text-uppercase">
            <option>Tea</option>
          </select>
        </div>
  	 		<div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	</div>
       <div class="righcontent wrapitem">
        	<div class="datebox" style="float:right">
          <button @click="backToSov" style="width:max-content;float:right" class="btn btn-block weavrpurple" type="button">
            <i class="fa fa-arrow-left"></i>
            <span style="font-size:13px"> Back</span>
          </button>
        </div>
      </div>
  	</div>
    <div class="container-fluid ">
      <div class="">
        <div class="card p-2">
          <div class="amd-legend"> 
          
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffb9b9!important"></i>
              <span>dabur</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #c7e0ff!important"></i>
              <span>vahdam</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffd0f5 !important"></i>
              <span>typhoo</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #edf2fb!important"></i>
              <span>organic india</span>
            </div>
          </div>  
          <table id="myTable2" class="table table-striped table-bordered">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
                <tr>
                  <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                </tr>
              </tfoot> 
            <tbody class="tbody-normal" > 
              <tr v-for="(r,i) in rows_details"  :key="i" :class="{'markitamd':r['brand'] == 'dabur',
                'markitintel':r['brand'] == 'vahdam','markitsnap':r['brand'] == 'typhoo','markitna':r['brand'] == 'organic india'}">
                <td v-for="d in columns_details" :key="d.field" > 
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{r[d.field]}}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span>{{r[d.field]}}</span>
                    </span>
                    <span v-else>-</span>  
                  </span>
                </td>
              </tr>
            </tbody>
          </table> 
        </div>   
      </div>  
    </div>  
    <b-modal size="lg" title="Audit" v-model="showAuditModal" >
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
               {{ d.label  }} 
              <span  v-if="d.field == 'compliance_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn> 
              </span>   
              <span  v-if="d.field == 'position_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'sku_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'rating_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn> 
              </span>  
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rowsAudit" :key="i">
            <td v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
              {{r[d.field]}} 
            </td>
          </tr>
        </tbody>
      </table>   
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }}
            <span  v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'category_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }} 
            <span  v-if="d.field == 'logo'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'image_count'">
                <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'nomenclature'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'message'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'sovdetail',
  components: { Datepicker},
  data: function () {
    return {
    	selected_website:localStorage.selected_website,
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      columns_details:[
        {label: 'Rank', field: 'order'},
        {label: 'Page', field: 'page'},
        {label: 'Brand', field: 'brand'},
        {label: 'Name', field: 'product_name',sortable: false},
        {label: 'Price', field: 'price',sortable: false},
        {label: 'Offer', field: 'offer',sortable: false},
        {label: 'Reviews', field: 'reviews'},
        {label: 'Ratings', field: 'ratings'}
      ],
      rows:[],
      rows_details:[],
      page:1,   
      showAuditModal: false,
      columnsAudit:[
        {label: 'SKU', field: 'sku', sortable: false},
        {label: 'Compliance Score', field:'compliance_score', sortable: false},
        {label: 'Position Score', field: 'position_score', sortable: false},
        {label: 'Rating Score', field: 'rating_score', sortable: false},
        {label: 'SKU Score', field: 'sku_score', sortable: false},
      ],
      columns_category:[
        {label: 'Category Position', field: 'category_position',sortable: false},
        {label: 'Category page position (1-3)', field: 'category_13_position',sortable: false},
        {label: 'Search Position', field: 'search_position',sortable: false},
        {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false}
      ],
      columns_compliance:[
        {label: 'Product Logo', field: 'logo',sortable: false},
        {label: 'OEM Images', field: 'image_count',sortable: false},
        {label: 'Nomenclature', field: 'nomenclature',sortable: false},
        {label: 'Message', field: 'message',sortable: false}
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false
    }
  },
  mounted()
  {
    this.website_details()
  },
  methods: {
    backToSov()
    { 
      window.location = '#/sov-summary-dabur'

    },
    showHeroChange(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(self.isHero)
        {
          if(dataset.is_hero)
          {
            this.rows_details.push(dataset)
          }  
        }  
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
   
    openAuditModal(r){
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },
    
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      $('#myTable2').DataTable().destroy();
      localStorage.selected_website = this.selected_website
      this.website_details()
    },
  
    website_details(){
      let self = this
      self.loader = true
      this.rows_details = []
      this.rows_details_full = []
      const url = "/api/websites/details"
      this.$http.post(url, { "website": this.selected_website,"timestamp":this.date.startDate }).then(response => {
        let resData = [
  {
    "order": 1,
    "price": "Rs 415.00",
    "offer": "Rs 470.00",
    "page": 1,
    "link": "https://www.amazon.in//Lipton-Honey-Lemon-Green-Pieces/dp/B01HMQ4HLW/",
    "page_count": 48,
    "reviews": 2453,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Lipton Honey Lemon Green Tea Bags, 100 Pc",
    "item_id": "B01HMQ4HLW",
    "brand": "lipton"
  },
  {
    "order": 2,
    "price": "Rs 412.00",
    "offer": "Rs 500.00",
    "page": 1,
    "link": "https://www.amazon.in//Tetley-Green-Ginger-Mint-Lemon/dp/B00MGFZEVW/",
    "page_count": 48,
    "reviews": 1842,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Tetley Green Tea Immune with Added Vitamin C Ginger Mint & Lemon 100 Tea Bags",
    "item_id": "B00MGFZEVW",
    "brand": "tetley"
  },
  {
    "order": 3,
    "price": "Rs 401.00",
    "offer": "Rs 500.00",
    "page": 1,
    "link": "https://www.amazon.in//Tetley-Green-Lemon-Honey-Bags/dp/B00MGFZGVK/",
    "page_count": 48,
    "reviews": 1725,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Tetley Green Tea Immune with Added Vitamin C  Lemon & Honey 100 Tea Bags",
    "item_id": "B00MGFZGVK",
    "brand": "tetley"
  },
  {
    "order": 4,
    "price": "Rs 297.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Lipton-Loose-Green-Tea-250g/dp/B00Z32QM5C/",
    "page_count": 48,
    "reviews": 1939,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Lipton Pure & Light Green Tea, Loose Green Tea, 250 g",
    "item_id": "B00Z32QM5C",
    "brand": "lipton"
  },
  {
    "order": 5,
    "price": "",
    "offer": "Rs 174.00",
    "page": 1,
    "link": "https://www.amazon.in//Tata-Tea-Tulsi-Green-Bags/dp/B08NWCFX16/",
    "page_count": 48,
    "reviews": 12,
    "ratings": 3.6,
    "image_count": 6,
    "product_name": "Tata Tea Tulsi Green Tea Bags 25s",
    "item_id": "B08NWCFX16",
    "brand": "tata"
  },
  {
    "order": 6,
    "price": "Rs 330.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Girnar-Green-Desi-Kahwa-Bags/dp/B01CE7D8BY/",
    "page_count": 48,
    "reviews": 3044,
    "ratings": 4.6,
    "image_count": 7,
    "product_name": "Girnar Detox Green Tea - Desi Kahwa (36 Tea Bags)",
    "item_id": "B01CE7D8BY",
    "brand": "girnar food & beverages pvt. ltd."
  },
  {
    "order": 7,
    "price": "Rs 330.00",
    "offer": "Rs 450.00",
    "page": 1,
    "link": "https://www.amazon.in//Amazon-Brand-Vedaka-Green-Lemon/dp/B07KJRWMF3/",
    "page_count": 48,
    "reviews": 334,
    "ratings": 4,
    "image_count": 6,
    "product_name": "Amazon Brand - Vedaka Green Tea, Lemon and Honey, (100 Bags)",
    "item_id": "B07KJRWMF3",
    "brand": "vedaka"
  },
  {
    "order": 8,
    "price": "Rs 169.00",
    "offer": "Rs 225.00",
    "page": 1,
    "link": "https://www.amazon.in//Onlyleaf-Natural-Immunity-Boosting-Different/dp/B08FL9JN9T/",
    "page_count": 48,
    "reviews": 777,
    "ratings": 4.2,
    "image_count": 5,
    "product_name": "Onlyleaf 100% Natural Immunity Boosting Green Tea Sampler Box, 20 Pyramid Tea Bags of 10 Different Exotic Flavors",
    "item_id": "B08FL9JN9T",
    "brand": "onlyleaf"
  },
  {
    "order": 9,
    "price": "Rs 218.00",
    "offer": "Rs 230.00",
    "page": 1,
    "link": "https://www.amazon.in//Organic-India-Tulsi-Green-100g/dp/B075J4CCRM/",
    "page_count": 48,
    "reviews": 974,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Organic India Classic Tulsi Green Tea, 100 gm",
    "item_id": "B075J4CCRM",
    "brand": "organic india"
  },
  {
    "order": 10,
    "price": "Rs 383.00",
    "offer": "Rs 470.00",
    "page": 1,
    "link": "https://www.amazon.in//Lipton-Pure-Light-Green-Pieces/dp/B01A6S21V6/",
    "page_count": 48,
    "reviews": 1088,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Lipton Pure & Light Green Tea Bags, 100 Pc",
    "item_id": "B01A6S21V6",
    "brand": "lipton"
  },
  {
    "order": 11,
    "price": "Rs 180.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Society-Tea-Premium-Green-250g/dp/B00WMNYFQ8/",
    "page_count": 48,
    "reviews": 854,
    "ratings": 4.2,
    "image_count": 5,
    "product_name": "Society Tea Premium Green Tea 250G Jar",
    "item_id": "B00WMNYFQ8",
    "brand": "society tea"
  },
  {
    "order": 12,
    "price": "Rs 165.00",
    "offer": "Rs 174.00",
    "page": 1,
    "link": "https://www.amazon.in//Organic-India-Tulsi-Green-Ginger/dp/B078HQWWVF/",
    "page_count": 48,
    "reviews": 895,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Organic India Tulsi Green Tea Lemon Ginger 25 TB",
    "item_id": "B078HQWWVF",
    "brand": "organic india"
  },
  {
    "order": 13,
    "price": "Rs 140.00",
    "offer": "Rs 175.00",
    "page": 1,
    "link": "https://www.amazon.in//Suraksha-Immunity-Goodness-Ayurvedic-Daalchini/dp/B08CFYJ13R/",
    "page_count": 48,
    "reviews": 108,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Dabur Vedic Suraksha Green Tea | Builds Immunity | Contains Ayurvedic Herbs Like Tulsi , Daalchini , Shunthi , Black Pepper and Kishmish -25 Tea Bags",
    "item_id": "B08CFYJ13R",
    "brand": "dabur"
  },
  {
    "order": 14,
    "price": "Rs 413.00",
    "offer": "Rs 470.00",
    "page": 1,
    "link": "https://www.amazon.in//Lipton-Honey-Lemon-Green-Bags/dp/B07C5ZYKYP/",
    "page_count": 48,
    "reviews": 214,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Lipton Honey Lemon Green Tea Bags, 100 Pc",
    "item_id": "B07C5ZYKYP",
    "brand": "lipton"
  },
  {
    "order": 15,
    "price": "",
    "offer": "Rs 160.00",
    "page": 1,
    "link": "https://www.amazon.in//Tetley-Green-Tea-Reviving-Mango/dp/B084BGVM5C/",
    "page_count": 48,
    "reviews": 118,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Tetley Green Tea Immune with Added Vitamin C  Mango 25 Tea Bags",
    "item_id": "B084BGVM5C",
    "brand": "tetley"
  },
  {
    "order": 16,
    "price": "Rs 499.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//VAHDAM-Japanese-ANTI-OXIDANTS-Metabolism-Everyday/dp/B01CXZ86FA/",
    "page_count": 48,
    "reviews": 692,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "VAHDAM- Certified Japanese Matcha Green Tea Powder - 50 gm (25 Servings) |100% Pure Authentic Japanese Matcha Powder",
    "item_id": "B01CXZ86FA",
    "brand": "vahdam"
  },
  {
    "order": 17,
    "price": "Rs 219.00",
    "offer": "Rs 299.00",
    "page": 1,
    "link": "https://www.amazon.in//TEACURRY-Slimming-Pyramid-Prevent-Teabags/dp/B08K7VRCQ8/",
    "page_count": 48,
    "reviews": 33,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "TEACURRY - 28 Day Slimming Tea for Weight Loss with Free Diet Chart | 10 Pyramid Slimming Tea Bags | Lose Weight, Reduce Tummy, Prevent Ageing | Weight Loss Tea (10 Pyramid Teabags | 20 Cups)",
    "item_id": "B08K7VRCQ8",
    "brand": "teacurry"
  },
  {
    "order": 18,
    "price": "Rs 350.00",
    "offer": "Rs 650.00",
    "page": 1,
    "link": "https://www.amazon.in//Typhoo-Green-Tea-100-Bags/dp/B00LRHAAXM/",
    "page_count": 48,
    "reviews": 753,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Typhoo Pure Natural Green Tea Bags, 100 Bags",
    "item_id": "B00LRHAAXM",
    "brand": "typhoo"
  },
  {
    "order": 19,
    "price": "",
    "offer": "Rs 575.00",
    "page": 1,
    "link": "https://www.amazon.in//ONLYLEAF-Natural-Cleanse-Pyramid-Samples/dp/B08FHZXDZM/",
    "page_count": 48,
    "reviews": 1161,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "ONLYLEAF Detox Kahwa Green Tea for Natural Body Cleanse & Cold Relief, Made with 100% Indian Herbs & Spices, 52 Pyramid Tea Bags (50 Tea Bags + 2 Free Samples)",
    "item_id": "B08FHZXDZM",
    "brand": "onlyleaf"
  },
  {
    "order": 20,
    "price": "",
    "offer": "Rs 470.00",
    "page": 1,
    "link": "https://www.amazon.in//Tetley-Green-Tea-Regular-Bags/dp/B00MGFZIO0/",
    "page_count": 48,
    "reviews": 538,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Tetley Green Tea Immune with Added Vitamin C  Classic Regular 100 Tea Bags",
    "item_id": "B00MGFZIO0",
    "brand": "tetley"
  },
  {
    "order": 21,
    "price": "Rs 400.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Tetley-Long-Leaf-Green-500g/dp/B00MGFZ656/",
    "page_count": 48,
    "reviews": 194,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "Tetley Green Tea Packet, 500g",
    "item_id": "B00MGFZ656",
    "brand": "tetley"
  },
  {
    "order": 22,
    "price": "Rs 412.00",
    "offer": "Rs 500.00",
    "page": 1,
    "link": "https://www.amazon.in//Tetley-Green-Ginger-Mint-Lemon/dp/B01N306RQ7/",
    "page_count": 48,
    "reviews": 224,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "Tetley Green Tea Immune with Added Vitamin C, Ginger, Mint & Lemon, 100 Tea Bags",
    "item_id": "B01N306RQ7",
    "brand": "tetley"
  },
  {
    "order": 23,
    "price": "",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Organic-India-Tulsi-Green-Bags/dp/B00AHUER16/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 1,
    "product_name": "Organic India Tulsi Green Tea Classic - 25 Tea Bags",
    "item_id": "",
    "brand": ""
  },
  {
    "order": 24,
    "price": "Rs 105.00",
    "offer": "\nRs 140.00",
    "page": 1,
    "link": "https://www.amazon.in//Vedaka-Green-Lemon-Honey-Bags/dp/B07KJRXD9V",
    "page_count": 48,
    "reviews": 17,
    "ratings": 3.8,
    "image_count": 6,
    "product_name": "Amazon Brand - Vedaka Green Tea, Lemon and Honey, 25 Bags",
    "item_id": "B07KJRXD9V",
    "brand": "amazon brand - vedaka"
  },
  {
    "order": 25,
    "price": "Rs 412.00",
    "offer": "Rs 470.00",
    "page": 1,
    "link": "https://www.amazon.in//Tetley-Green-Lemon-Honey-Bags/dp/B01CHVQ7D8/",
    "page_count": 48,
    "reviews": 520,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Tetley Green Tea Immune with added Vitamin C, Lemon and Honey, 100 Tea Bags",
    "item_id": "B01CHVQ7D8",
    "brand": "tetley"
  },
  {
    "order": 26,
    "price": "Rs 275.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Lipton-Loose-Leaf-Green-250g/dp/B01H5LFD80/",
    "page_count": 48,
    "reviews": 150,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Lipton Pure & Light Green Tea, Loose Green Tea, 250 g",
    "item_id": "B01H5LFD80",
    "brand": "lipton"
  },
  {
    "order": 27,
    "price": "",
    "offer": "Rs 174.00",
    "page": 1,
    "link": "https://www.amazon.in//Tata-Tea-Tulsi-Green-Bags/dp/B07WMSG5GB/",
    "page_count": 48,
    "reviews": 57,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Tata Tea Tulsi Green Tea Bags 25s",
    "item_id": "B07WMSG5GB",
    "brand": "tata tea tulsi green"
  },
  {
    "order": 28,
    "price": "Rs 160.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Tetley-Green-Ginger-Mint-Lemon/dp/B0795VCQJP/",
    "page_count": 48,
    "reviews": 549,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Tetley Green Tea Bags, Ginger Mint Lemon, 25 Tea Bags",
    "item_id": "B0795VCQJP",
    "brand": "tetley"
  },
  {
    "order": 29,
    "price": "Rs 325.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Apsara-Tea-Detox-Kahwa-Green/dp/B07XJC99WM/",
    "page_count": 48,
    "reviews": 148,
    "ratings": 4.1,
    "image_count": 4,
    "product_name": "APSARA Detox Kahwa Green Tea | Immunity Boosting Properties | Antioxidants Properties | 36 Tea Bag",
    "item_id": "B07XJC99WM",
    "brand": "apsara"
  },
  {
    "order": 30,
    "price": "Rs 499.00",
    "offer": "Rs 699.00",
    "page": 1,
    "link": "https://www.amazon.in//Heapwell-Japanese-Matcha-Green-Powder/dp/B06XTYYYJ8/",
    "page_count": 48,
    "reviews": 498,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Japanese Matcha Green Tea Powder 50g (Premium Grade) - by Heapwell Superfoods",
    "item_id": "B06XTYYYJ8",
    "brand": "heapwell superfoods"
  },
  {
    "order": 31,
    "price": "",
    "offer": "Rs 250.00",
    "page": 1,
    "link": "https://www.amazon.in//Onlyleaf-Chamomile-Green-Exotic-Samples/dp/B07D9W9H5P/",
    "page_count": 48,
    "reviews": 948,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "ONLYLEAF Chamomile Green Tea For Stress Relief & Good Sleep, Made with 100% Whole Leaf & Natural Chamomile Flowers, 27 Pyramid Tea Bags (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07D9W9H5P",
    "brand": "onlyleaf"
  },
  {
    "order": 32,
    "price": "",
    "offer": "Rs 175.00",
    "page": 1,
    "link": "https://www.amazon.in//Dabur-Vedic-Suraksha-Green-Tea/dp/B08DBBSNFZ/",
    "page_count": 48,
    "reviews": 115,
    "ratings": 4.7,
    "image_count": 6,
    "product_name": "Dabur Vedic Suraksha Green Tea- 25 Tea Bags",
    "item_id": "B08DBBSNFZ",
    "brand": "dabur"
  },
  {
    "order": 33,
    "price": "Rs 249.00",
    "offer": "Rs 280.00",
    "page": 1,
    "link": "https://www.amazon.in//Twinings-Teabags-Perfectly-Balanced-Refreshing/dp/B0895WJ31H/",
    "page_count": 48,
    "reviews": 12,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Twinings Pure Green Tea, 25 Teabags, Green Tea, Perfectly Balanced & Refreshing",
    "item_id": "B0895WJ31H",
    "brand": "twinings"
  },
  {
    "order": 34,
    "price": "",
    "offer": "Rs 300.00",
    "page": 1,
    "link": "https://www.amazon.in//Onlyleaf-Detox-Kahwa-Exotic-Samples/dp/B07R4SFWK4/",
    "page_count": 48,
    "reviews": 477,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "ONLYLEAF Detox Kahwa Green Tea (27 Pyramid Tea Bags) For Natural Body Cleanse & Cold Relief, Made with 100% Indian Herbs & Spices (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07R4SFWK4",
    "brand": "onlyleaf"
  },
  {
    "order": 35,
    "price": "",
    "offer": "Rs 525.00",
    "page": 1,
    "link": "https://www.amazon.in//Onlyleaf-Dandelion-Green-Exotic-Samples/dp/B07D9V7L82/",
    "page_count": 48,
    "reviews": 44,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "ONLYLEAF Dandelion Green Tea, Made with 100% Whole Leaf & Natural Dandelion Roots, 52 Pyramid Tea Bags (50 Tea Bags + 2 Free Samples)",
    "item_id": "B07D9V7L82",
    "brand": "onlyleaf"
  },
  {
    "order": 36,
    "price": "Rs 249.00",
    "offer": "Rs 285.00",
    "page": 1,
    "link": "https://www.amazon.in//Twinings-Jasmine-Green-Tea-Bags/dp/B00MVO4130/",
    "page_count": 48,
    "reviews": 37,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Twinings Jasmine and Green Tea, 25 Tea Bags",
    "item_id": "B00MVO4130",
    "brand": "twinings"
  },
  {
    "order": 37,
    "price": "Rs 240.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Ashwagandha-Metabolism-Immunity-Ayurvedic-Cinnamon/dp/B08335PC45/",
    "page_count": 48,
    "reviews": 361,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Care Ashwagandha Spiced Green Tea for Weight Loss & Build Immunity | Detox Desi Kahwa Green Tea with Herbs Like Cinnamon, Tulsi, Ginger - 25 Tea Bags",
    "item_id": "B08335PC45",
    "brand": "care"
  },
  {
    "order": 38,
    "price": "",
    "offer": "Rs 275.00",
    "page": 1,
    "link": "https://www.amazon.in//Onlyleaf-Hibiscus-Cinnamon-Exotic-Samples/dp/B07D9V1ZPN/",
    "page_count": 48,
    "reviews": 326,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "ONLYLEAF Hibiscus Cinnamon Clove Green Tea (27 Pyramid Tea Bags) Made with 100% Whole Leaf, Natural Hibiscus, Cinnamon & Clove (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07D9V1ZPN",
    "brand": "onlyleaf"
  },
  {
    "order": 39,
    "price": "Rs 299.00",
    "offer": "Rs 349.00",
    "page": 1,
    "link": "https://www.amazon.in//Chaayos-Turmeric-Cardamom-Immunity-Boosting/dp/B08BTNCSL4/",
    "page_count": 48,
    "reviews": 101,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Chaayos Turmeric Cardamom Green Tea | Whole Leaf Loose Tea | Immunity Boosting - 100g [50 Cups] | Green Tea | Weight Loss",
    "item_id": "B08BTNCSL4",
    "brand": "chaayos"
  },
  {
    "order": 40,
    "price": "Rs 149.00",
    "offer": "Rs 229.00",
    "page": 1,
    "link": "https://www.amazon.in//SPRIG-TE-Tulsi-Ginger-Combo/dp/B08KQ3Q7LR/",
    "page_count": 48,
    "reviews": 25,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "SPRIG TE.A Tulsi, Ginger & Mint Combo - Triple The Goodness of Fully Soluble Green Tea | Unique, Refreshing, Natural Flavours That aid in Boosting Immunity | Packs of 10",
    "item_id": "B08KQ3Q7LR",
    "brand": "sprig te.a"
  },
  {
    "order": 41,
    "price": "",
    "offer": "Rs 174.00",
    "page": 1,
    "link": "https://www.amazon.in//Tata-Tulsi-Green-Paper-Pouch/dp/B07WFPQ5HV/",
    "page_count": 48,
    "reviews": 52,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Tata Tea Tulsi Green Paper Pouch 100 g",
    "item_id": "B07WFPQ5HV",
    "brand": "tata tea tulsi green"
  },
  {
    "order": 42,
    "price": "",
    "offer": "Rs 174.00",
    "page": 1,
    "link": "https://www.amazon.in//Tata-Tea-Tulsi-Green-Paper/dp/B085S3M6TV/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 3.3,
    "image_count": 6,
    "product_name": "Tata Tea Tulsi Green Paper Pouch 100g",
    "item_id": "B085S3M6TV",
    "brand": "tata"
  },
  {
    "order": 43,
    "price": "Rs 335.00",
    "offer": "Rs 350.00",
    "page": 1,
    "link": "https://www.amazon.in//Organic-India-Tulsi-Green-100gms/dp/B01IHT46E6/",
    "page_count": 48,
    "reviews": 36,
    "ratings": 4.6,
    "image_count": 7,
    "product_name": "Organic India Tulsi Green Tea 100gms(Pack of 2)",
    "item_id": "B01IHT46E6",
    "brand": "organic india"
  },
  {
    "order": 44,
    "price": "Rs 399.00",
    "offer": "Rs 449.00",
    "page": 1,
    "link": "https://www.amazon.in//SPARKHEALTH-Green-Flavoured-Tablets-Tablet/dp/B0899H9FCZ/",
    "page_count": 48,
    "reviews": 34,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "SPARKHEALTH Green Tea Lemon Flavoured Sugar Free Tablets \"The Magic Taste of Life\" 60 Tablet Green Tea",
    "item_id": "B0899H9FCZ",
    "brand": "sparkhealth"
  },
  {
    "order": 45,
    "price": "Rs 299.00",
    "offer": "Rs 349.00",
    "page": 1,
    "link": "https://www.amazon.in//FARGANIC-Weight-Natural-Herbal-Green/dp/B07SSTG152/",
    "page_count": 48,
    "reviews": 177,
    "ratings": 3.7,
    "image_count": 6,
    "product_name": "Farganic 15 Days Weight Loss Green Tea. 100% Natural and Herbal. Day Time Tea, Bed Time Tea. Slimming Tea. 30 Tea Bags ( 15+15). Weight Loss. (Pack of 1)",
    "item_id": "B07SSTG152",
    "brand": "farganic"
  },
  {
    "order": 46,
    "price": "Rs 179.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Typhoo-Green-Tea-Loose-200g/dp/B00KWU2SJY/",
    "page_count": 48,
    "reviews": 264,
    "ratings": 4.1,
    "image_count": 5,
    "product_name": "Typhoo Pure Green Tea Leaf Loose (200gm)",
    "item_id": "B00KWU2SJY",
    "brand": "typhoo"
  },
  {
    "order": 47,
    "price": "Rs 175.00",
    "offer": "",
    "page": 1,
    "link": "https://www.amazon.in//Eco-Valley-Natural-Ginger-Mulethi/dp/B00M4ZB8J6/",
    "page_count": 48,
    "reviews": 183,
    "ratings": 4,
    "image_count": 5,
    "product_name": "Eco Valley Organic Green Tea, Ginger, Lemon and Mulethi, 30 Tea Bags",
    "item_id": "B00M4ZB8J6",
    "brand": "eco valley"
  },
  {
    "order": 48,
    "price": "",
    "offer": "Rs 285.00",
    "page": 1,
    "link": "https://www.amazon.in//Twinings-Green-Lemon-Honey-Bags/dp/B00L942Q3U/",
    "page_count": 48,
    "reviews": 115,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Twinings Green Tea Lemon & Honey, 25 Teabags, Green Tea, Sweet Honey & Tangy Lemon",
    "item_id": "B00L942Q3U",
    "brand": "twinings"
  },
  {
    "order": 49,
    "price": "",
    "offer": "Rs 300.00",
    "page": 2,
    "link": "https://www.amazon.in//Onlyleaf-Ashwagandha-Green-Exotic-Samples/dp/B07R285W8R/",
    "page_count": 48,
    "reviews": 94,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "ONLYLEAF Ashwagandha Green Tea for Immunity Boosting & Improved Memory, Made with 100% Whole Leaf, Natural Ashwagandha & Cardamom, 27 Pyramid Tea Bags (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07R285W8R",
    "brand": "onlyleaf"
  },
  {
    "order": 50,
    "price": "Rs 200.00",
    "offer": "",
    "page": 2,
    "link": "https://www.amazon.in//Wagh-Bakri-Green-Shudh-Kahwa/dp/B07YF2TW6R/",
    "page_count": 48,
    "reviews": 21,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Wagh Bakri Green Tea Shudh Kahwa Tea Bag, 25 Tea Bag*2.5g, 62.5g",
    "item_id": "B07YF2TW6R",
    "brand": "wagh bakri"
  },
  {
    "order": 51,
    "price": "Rs 699.00",
    "offer": "",
    "page": 2,
    "link": "https://www.amazon.in//OZiva-Plant-Based-Matcha-Plus/dp/B081B48TW8/",
    "page_count": 48,
    "reviews": 110,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "OZiva Plant Based Matcha Plus - Organic Japanese Matcha Green Tea for Skin Pigmentation & Dark Circles, 50g",
    "item_id": "B081B48TW8",
    "brand": "oziva"
  },
  {
    "order": 52,
    "price": "Rs 255.00",
    "offer": "Rs 300.00",
    "page": 2,
    "link": "https://www.amazon.in//Himalaya-Green-Tea-Lemon-60S/dp/B081H7KZ36/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 3.8,
    "image_count": 5,
    "product_name": "Himalaya Green Tea Lemon 2 g 60'S",
    "item_id": "B081H7KZ36",
    "brand": "himalaya"
  },
  {
    "order": 53,
    "price": "",
    "offer": "Rs 399.00",
    "page": 2,
    "link": "https://www.amazon.in//Chaayos-Gods-Chai-Ayurvedic-Immunity/dp/B08GL2PPRF/",
    "page_count": 48,
    "reviews": 18,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Chaayos God's Chai - Herbal Kangra Green Tea | Ayurvedic Immunity Booster | Tasty Detox Tea | 100g [50 Cups] | Green Tea",
    "item_id": "B08GL2PPRF",
    "brand": "chaayos"
  },
  {
    "order": 54,
    "price": "",
    "offer": "Rs 275.00",
    "page": 2,
    "link": "https://www.amazon.in//Onlyleaf-Rose-Green-Exotic-Samples/dp/B07R39YFDN/",
    "page_count": 48,
    "reviews": 201,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "ONLYLEAF Rose Green Tea For Glowing Skin, Made with 100% Whole Leaf & Natural Rose Petals, 27 Pyramid Tea Bags (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07R39YFDN",
    "brand": "onlyleaf"
  },
  {
    "order": 55,
    "price": "Rs 330.00",
    "offer": "",
    "page": 2,
    "link": "https://www.amazon.in//Girnar-Green-Tea-Detox-90g/dp/B011RIAJR2/",
    "page_count": 48,
    "reviews": 30,
    "ratings": 4.5,
    "image_count": 1,
    "product_name": "Girnar Green Tea Detox (90g)",
    "item_id": "B011RIAJR2",
    "brand": "girnar"
  },
  {
    "order": 56,
    "price": "",
    "offer": "Rs 910.00",
    "page": 2,
    "link": "https://www.amazon.in//Twinings-Green-Tea-100-Bags/dp/B006QQPUXY/",
    "page_count": 48,
    "reviews": 139,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Twinings Pure Green Tea, 100 Teabags, Green Tea, Perfectly Balanced & Refreshing",
    "item_id": "B006QQPUXY",
    "brand": "twinings"
  },
  {
    "order": 57,
    "price": "",
    "offer": "Rs 598.00",
    "page": 2,
    "link": "https://www.amazon.in//METALEAN-GREEN-TEA-BAGS-SACHET/dp/B07B3YJXCK/",
    "page_count": 48,
    "reviews": 8,
    "ratings": 3.8,
    "image_count": 4,
    "product_name": "Farganic Organic Metabolean / Metalean Slimming Green Tea for Weight Loss Fast. Rich in Antioxidants, Improves Metabolism, Boost Immunity and Detox Body 30 Tea Bags (Pack of 2)",
    "item_id": "B07B3YJXCK",
    "brand": "metalean"
  },
  {
    "order": 58,
    "price": "",
    "offer": "Rs 400.00",
    "page": 2,
    "link": "https://www.amazon.in//TGL-Green-Sampler-Assortment-Pyramid/dp/B082YHC2T8/",
    "page_count": 48,
    "reviews": 12,
    "ratings": 4.6,
    "image_count": 4,
    "product_name": "TGL Green Tea Sampler, Tea Assortment | 10 Teas, 2 Pyramid Tea Bag of Each | Best of Green Tea Bags | 20 Green Tea Bags",
    "item_id": "B082YHC2T8",
    "brand": "tgl co. the good life company"
  },
  {
    "order": 59,
    "price": "Rs 174.00",
    "offer": "",
    "page": 2,
    "link": "https://www.amazon.in//Organic-India-Tulsi-Green-Pomegranate/dp/B0779RRDV3/",
    "page_count": 48,
    "reviews": 237,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Organic India Tulsi Green Tea, Pomegranate, 25 Tea Bags",
    "item_id": "B0779RRDV3",
    "brand": "organic india"
  },
  {
    "order": 60,
    "price": "Rs 399.00",
    "offer": "Rs 499.00",
    "page": 2,
    "link": "https://www.amazon.in//Exotic-Aromas-Moringa-Hibiscus-Premium/dp/B08L1BXN7Z/",
    "page_count": 48,
    "reviews": 189,
    "ratings": 4.7,
    "image_count": 7,
    "product_name": "Exotic Aromas Herbal Detox Green Tea with Moringa, Hibiscus and Premium Blend of Herbs , 100g",
    "item_id": "B08L1BXN7Z",
    "brand": "exotic aromas"
  },
  {
    "order": 61,
    "price": "Rs 175.00",
    "offer": "",
    "page": 2,
    "link": "https://www.amazon.in//Eco-Valley-Natural-Green-Dandelion/dp/B00M4ZB3K0/",
    "page_count": 48,
    "reviews": 302,
    "ratings": 4.1,
    "image_count": 1,
    "product_name": "Eco Valley Organic Green Tea, Dandelion and Mint, 30 Tea Bags",
    "item_id": "B00M4ZB3K0",
    "brand": "eco valley"
  },
  {
    "order": 62,
    "price": "",
    "offer": "Rs 275.00",
    "page": 2,
    "link": "https://www.amazon.in//Onlyleaf-Dandelion-Green-Exotic-Samples/dp/B07D9TKVX6/",
    "page_count": 48,
    "reviews": 176,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "ONLYLEAF Dandelion Green Tea, Made with 100% Whole Leaf & Natural Dandelion Roots, 27 Pyramid Tea Bags (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07D9TKVX6",
    "brand": "onlyleaf"
  },
  {
    "order": 63,
    "price": "Rs 369.00",
    "offer": "Rs 659.00",
    "page": 2,
    "link": "https://www.amazon.in//HAYMAN-NATURALS-Slimming-Garcinia-Lemongrass-100/dp/B08CRMMHCL/",
    "page_count": 48,
    "reviews": 9,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "HAYMAN NATURAL'S Slimming Green Tea (100g | 56cups) for Weight Loss and Belly Fat Made with Garcinia Cambogia, Lemongrass-100% Natural",
    "item_id": "B08CRMMHCL",
    "brand": "hayman natural's"
  },
  {
    "order": 64,
    "price": "Rs 358.00",
    "offer": "Rs 360.00",
    "page": 2,
    "link": "https://www.amazon.in//Dilmah-Sencha-Green-Tea-50g/dp/B00UV24OWC/",
    "page_count": 48,
    "reviews": 7,
    "ratings": 3.9,
    "image_count": 6,
    "product_name": "Dilmah Sencha Green Tea, 50g",
    "item_id": "B00UV24OWC",
    "brand": "dilmah"
  },
  {
    "order": 65,
    "price": "Rs 273.00",
    "offer": "Rs 300.00",
    "page": 2,
    "link": "https://www.amazon.in//Himalaya-Green-Tea-Tulasi-60S/dp/B08F8H8HTV/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 4.5,
    "image_count": 5,
    "product_name": "Himalaya Green Tea Tulasi 2g 60'S",
    "item_id": "B08F8H8HTV",
    "brand": "himalaya"
  },
  {
    "order": 66,
    "price": "",
    "offer": "Rs 349.00",
    "page": 2,
    "link": "https://www.amazon.in//TGL-Co-LUXURY-TEAS-Biodegradable/dp/B07JNHK2R6/",
    "page_count": 48,
    "reviews": 62,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "TGL Co. LUXURY TEAS Mogo Mogo Green Tea with Natural Fruits for Weight Loss, 16 Tea Bags",
    "item_id": "B07JNHK2R6",
    "brand": "tgl co. luxury teas"
  },
  {
    "order": 67,
    "price": "Rs 318.00",
    "offer": "Rs 390.00",
    "page": 2,
    "link": "https://www.amazon.in//Typhoo-UPLIFTNG-Green-Lemon-Grass/dp/B07NLCLB1H/",
    "page_count": 48,
    "reviews": 20,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Typhoo UPLIFTNG Green Tea, Lemon Grass, 25 Tea Bags (Pack of 2)",
    "item_id": "B07NLCLB1H",
    "brand": "typhoo"
  },
  {
    "order": 68,
    "price": "Rs 299.00",
    "offer": "Rs 599.00",
    "page": 2,
    "link": "https://www.amazon.in//Jarved-Organic-Orthodox-Natural-Handmade/dp/B077ZB8LJ2/",
    "page_count": 48,
    "reviews": 402,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Jarved 100% Organic Orthodox Whole Leaf Natural Handmade Assam Green Tea: Single Blend, FTGFOP1 Grade, USDA Certified, Antioxidants Rich(45 Cups, 3.53oz) in Eco Friendly Tin Jar- Farm to Cup",
    "item_id": "B077ZB8LJ2",
    "brand": "jarved"
  },
  {
    "order": 69,
    "price": "Rs 449.00",
    "offer": "Rs 999.00",
    "page": 2,
    "link": "https://www.amazon.in//Chaiology-Himalayan-Loose-Leaf-Green/dp/B07JFH461S/",
    "page_count": 48,
    "reviews": 780,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "CHAIOLOGY Himalayan Green Tea 250 Cups- 500 Gm, Premium Loose Leaf Green Tea.",
    "item_id": "B07JFH461S",
    "brand": "chaiology"
  },
  {
    "order": 70,
    "price": "",
    "offer": "Rs 450.00",
    "page": 2,
    "link": "https://www.amazon.in//Amazon-Brand-Vedaka-Green-Lemon/dp/B07KJ5S8P7/",
    "page_count": 48,
    "reviews": 87,
    "ratings": 4.1,
    "image_count": 6,
    "product_name": "Amazon Brand - Vedaka Green Tea, Lemon and Honey, 100 Bags",
    "item_id": "B07KJ5S8P7",
    "brand": "vedaka"
  },
  {
    "order": 71,
    "price": "Rs 350.00",
    "offer": "Rs 360.00",
    "page": 2,
    "link": "https://www.amazon.in//Leefords-Green-Combo-Weight-Refreshing/dp/B08FF3GKDP/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 5,
    "product_name": "Leeford's Green Tea Combo Pack Of Aqua Slim And Lemon With Honey For Weight Loss and Refreshing Taste (25 Bags Each) Pack of 2 Total 50 Bags",
    "item_id": "B08FF3GKDP",
    "brand": "leeford"
  },
  {
    "order": 72,
    "price": "",
    "offer": "Rs 250.00",
    "page": 2,
    "link": "https://www.amazon.in//Onlyleaf-Mint-Green-Exotic-Samples/dp/B07D9TRRB6/",
    "page_count": 48,
    "reviews": 112,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "ONLYLEAF Mint Green Tea For Feeling Refreshed, Made with 100% Whole Leaf & Natural Flavors, 27 Pyramid Tea Bags (25 Tea Bags + 2 Free Samples) | Brew Hot or Cold",
    "item_id": "B07D9TRRB6",
    "brand": "onlyleaf"
  },
  {
    "order": 73,
    "price": "Rs 109.00",
    "offer": "Rs 595.00",
    "page": 2,
    "link": "https://www.amazon.in//Emeveta-Herbal-Instant-Tablets-tablets/dp/B084SDFCGQ/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 5,
    "image_count": 6,
    "product_name": "Emeveta Herbal Instant Green Tea Tablets with Rich Flavor 60 tablets",
    "item_id": "B084SDFCGQ",
    "brand": "emeveta"
  },
  {
    "order": 74,
    "price": "",
    "offer": "Rs 285.00",
    "page": 2,
    "link": "https://www.amazon.in//Twinings-Green-Tea-Mint-Bags/dp/B006QQPVO2/",
    "page_count": 48,
    "reviews": 77,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Twinings Green Tea & Mint, 25 Teabags, Green Tea, Cool & Refreshing Mint Flavour",
    "item_id": "B006QQPVO2",
    "brand": "twinings"
  },
  {
    "order": 75,
    "price": "",
    "offer": "Rs 285.00",
    "page": 2,
    "link": "https://www.amazon.in//Twinings-Green-Earl-Grey-Bags/dp/B00MVO44DW/",
    "page_count": 48,
    "reviews": 50,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Twinings Green Tea Earl Grey, 25 Teabags, Green Tea, Delicate Citrus, Bright & Perky",
    "item_id": "B00MVO44DW",
    "brand": "twinings"
  },
  {
    "order": 76,
    "price": "",
    "offer": "Rs 200.00",
    "page": 2,
    "link": "https://www.amazon.in//TGL-Green-Sampler-Assortment-Pyramid/dp/B082YGMY58/",
    "page_count": 48,
    "reviews": 26,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "TGL Co. The Good Life Company Green Tea Sampler Assortment, 10 Green Tea Bags, 1 Pyramid Tea Bag of Each",
    "item_id": "B082YGMY58",
    "brand": "tgl co. the good life company"
  },
  {
    "order": 77,
    "price": "Rs 299.00",
    "offer": "Rs 499.00",
    "page": 2,
    "link": "https://www.amazon.in//YOGAFY-Darjeeling-Green-Slimming-Weight/dp/B08C2RTV8Y/",
    "page_count": 48,
    "reviews": 19,
    "ratings": 3.9,
    "image_count": 7,
    "product_name": "YOGAFY - Darjeeling Green Tea | Pure Whole Leaf - Decaf Tea for Slimming and Weight Loss | 100 Gram - 100 Cups |",
    "item_id": "B08C2RTV8Y",
    "brand": "yogafy"
  },
  {
    "order": 78,
    "price": "Rs 499.00",
    "offer": "Rs 599.00",
    "page": 2,
    "link": "https://www.amazon.in//Jarved-Assam-Green-Leaves-Immunity/dp/B08BTQBQTK/",
    "page_count": 48,
    "reviews": 77,
    "ratings": 4.7,
    "image_count": 6,
    "product_name": "Jarved Assam Green Tea Leaves | 150g | Makes 75 Cups | For Immunity",
    "item_id": "B08BTQBQTK",
    "brand": "jarved"
  },
  {
    "order": 79,
    "price": "Rs 299.00",
    "offer": "Rs 349.00",
    "page": 2,
    "link": "https://www.amazon.in//FARGANIC-Weight-Health-Active-Ingredients/dp/B07P6LBLMF/",
    "page_count": 48,
    "reviews": 109,
    "ratings": 3.7,
    "image_count": 7,
    "product_name": "FARGANIC Detox Green Tea for Weight Loss and Skin Glow. 15 Days Detox Plan (30 Tea Bags) Tea and Health Series with Active Ingredients (Pack of 1)",
    "item_id": "B07P6LBLMF",
    "brand": "farganic"
  },
  {
    "order": 80,
    "price": "Rs 250.00",
    "offer": "Rs 255.00",
    "page": 2,
    "link": "https://www.amazon.in//Wingreens-Farms-Lemongrass-Green-Tea/dp/B016W9HH08/",
    "page_count": 48,
    "reviews": 5,
    "ratings": 3.9,
    "image_count": 3,
    "product_name": "Wingreens Farms Lemongrass with Green Tea (60 gm)",
    "item_id": "B016W9HH08",
    "brand": "wingreens farms"
  },
  {
    "order": 81,
    "price": "Rs 299.00",
    "offer": "Rs 599.00",
    "page": 2,
    "link": "https://www.amazon.in//Jarved-Organic-Whole-Assam-Green/dp/B077Z92K74/",
    "page_count": 48,
    "reviews": 142,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Jarved Organic Whole Leaf Assam Green Tea: 45 Day Herbal Detox and Slimming Tea, Premium Grade (100g Makes 45 Cups)",
    "item_id": "B077Z92K74",
    "brand": "jarved"
  },
  {
    "order": 82,
    "price": "Rs 179.00",
    "offer": "Rs 190.00",
    "page": 2,
    "link": "https://www.amazon.in//Organic-India-Tulsi-Ginger-100g/dp/B00Q4E4HWI/",
    "page_count": 48,
    "reviews": 248,
    "ratings": 4.5,
    "image_count": 3,
    "product_name": "Organic India Tulsi Ginger 100 GM Tin",
    "item_id": "B00Q4E4HWI",
    "brand": "organic india"
  },
  {
    "order": 83,
    "price": "Rs 485.00",
    "offer": "Rs 599.00",
    "page": 2,
    "link": "https://www.amazon.in//Real-Matcha-Japanese-Powder-Weight/dp/B07CWCHMF1/",
    "page_count": 48,
    "reviews": 24,
    "ratings": 4,
    "image_count": 7,
    "product_name": "Real Matcha Japanese Matcha Green Tea Powder for Weight Loss 50gm (50 Cups)",
    "item_id": "B07CWCHMF1",
    "brand": "real matcha"
  },
  {
    "order": 84,
    "price": "Rs 158.00",
    "offer": "Rs 195.00",
    "page": 2,
    "link": "https://www.amazon.in//Typhoo-Natural-Sealed-enveloped-Multi-colour/dp/B01N3BWP7D/",
    "page_count": 48,
    "reviews": 32,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Ty-phoo Natural Green Tea Lemon and Honey with 25 Heat Sealed Enveloped Bags, 25 Bags",
    "item_id": "B01N3BWP7D",
    "brand": "ty-phoo"
  },
  {
    "order": 85,
    "price": "",
    "offer": "Rs 550.00",
    "page": 2,
    "link": "https://www.amazon.in//Kimino-Japanese-Organic-Matcha-Green/dp/B01LY7IK29/",
    "page_count": 48,
    "reviews": 235,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Kimino Japanese Organic Matcha Green Tea, 30g",
    "item_id": "B01LY7IK29",
    "brand": "kimino"
  },
  {
    "order": 86,
    "price": "",
    "offer": "Rs 300.00",
    "page": 2,
    "link": "https://www.amazon.in//Twinings-Green-Tea-Strawberry-Bags/dp/B07F862HBX/",
    "page_count": 48,
    "reviews": 19,
    "ratings": 4,
    "image_count": 6,
    "product_name": "Twinings Green Tea Strawberry, 25 Teabags, Green Tea, Sweet Subtle Flavour of Strawberry",
    "item_id": "B07F862HBX",
    "brand": "twinings"
  },
  {
    "order": 87,
    "price": "",
    "offer": "Rs 179.00",
    "page": 2,
    "link": "https://www.amazon.in//SPRIG-TE-Green-Tulsi-Pack/dp/B07WM81VMV/",
    "page_count": 48,
    "reviews": 14,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "SPRIG TE.A Green Tea with Tulsi | Fully Soluble Green Tea | Balance Yourself with This Tonic for Wellness | Age-Old Health Ingredients for Immunity | Pack of 25",
    "item_id": "B07WM81VMV",
    "brand": "sprig te.a"
  },
  {
    "order": 88,
    "price": "Rs 409.00",
    "offer": "Rs 450.00",
    "page": 2,
    "link": "https://www.amazon.in//Nutrust-Garcenia-Probiotic-flavor-sachets/dp/B08CZNXKX4/",
    "page_count": 48,
    "reviews": 4,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Nutrust Slim Green Tea pack of 2 with Garcenia and Probiotic lemon flavor 40 sachets weight loss fast",
    "item_id": "B08CZNXKX4",
    "brand": "nutrust"
  },
  {
    "order": 89,
    "price": "Rs 225.00",
    "offer": "",
    "page": 2,
    "link": "https://www.amazon.in//VAHDAM-Natural-Ingredients-Digestion-Refreshing/dp/B08GG37QFX/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 5,
    "image_count": 6,
    "product_name": "VAHDAM, Ginger Mint Green Tea- 15 Tea Bags | 100% Natural Ingredients | Aids Digestion | Refreshing Detox: with Ginger & Mint, Certified Organic Tea | Antioxidant Rich | Boosts Immunity",
    "item_id": "B08GG37QFX",
    "brand": "vahdam"
  },
  {
    "order": 90,
    "price": "",
    "offer": "Rs 299.00",
    "page": 2,
    "link": "https://www.amazon.in//TGL-Co-Kashmiri-Saffron-Biodegradable/dp/B07F13278X/",
    "page_count": 48,
    "reviews": 69,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "TGL Co. LUXURY TEAS Kashmiri Kahwa Green Tea, 16 Tea Bags (15 Tea Bags with 1 Exotic Sample)",
    "item_id": "B07F13278X",
    "brand": "tgl co. luxury teas"
  },
  {
    "order": 91,
    "price": "",
    "offer": "Rs 499.00",
    "page": 2,
    "link": "https://www.amazon.in//Thyroid-Hyperthyroidism-Restore-Multivitamins-Chamomile/dp/B08NNZ4QMF/",
    "page_count": 48,
    "reviews": 118,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "&Me Thyroid Tea for Hyperthyroidism- Restore healthy T3, T4 levels, Manages Weight, Green Tea and Multivitamins (Chamomile Ginger Flavor, 30 Tea Bags)",
    "item_id": "B08NNZ4QMF",
    "brand": "& me"
  },
  {
    "order": 92,
    "price": "Rs 225.00",
    "offer": "",
    "page": 2,
    "link": "https://www.amazon.in//VAHDAM-Himalayan-Green-Pyramid-Natural/dp/B074MZC5MD/",
    "page_count": 48,
    "reviews": 36,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "VAHDAM, Organic Green Tea Leaves from Himalayas (15 Tea Bags), 100% Natural Weight Loss Tea, Detox Tea, Slimming Tea, ANTI-OXIDANTS RICH - Green Tea Loose Leaf - Brew Hot or Iced",
    "item_id": "B074MZC5MD",
    "brand": "vahdam"
  },
  {
    "order": 93,
    "price": "Rs 340.00",
    "offer": "Rs 400.00",
    "page": 2,
    "link": "https://www.amazon.in//Teamonk-Ashwagandha-Natural-Cinnamon-Additives/dp/B08HMWMWHK/",
    "page_count": 48,
    "reviews": 8,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Teamonk Ashwagandha Green Tea Loose Leaf (50 Cups) | 100% Natural Ashwagandha Tea | Green Tea Leaves with Ashwagandha, Tulsi, Cinnamon and Fennel | No Additives - 100 g",
    "item_id": "B08HMWMWHK",
    "brand": "teamonk"
  },
  {
    "order": 94,
    "price": "",
    "offer": "Rs 599.00",
    "page": 2,
    "link": "https://www.amazon.in//Healthy-Company-One-Week-Detox/dp/B086BHWMBQ/",
    "page_count": 48,
    "reviews": 25,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "The Healthy Company - One Week Detox (Box of 2) - Natural Lean Green Tea Sticks - Diabetes, PCOD, Thyroid & Keto - Men & Women - The Healthy Company",
    "item_id": "B086BHWMBQ",
    "brand": "the healthy company"
  },
  {
    "order": 95,
    "price": "Rs 250.00",
    "offer": "",
    "page": 2,
    "link": "https://www.amazon.in//Hillcart-Tales-Honey-Limon-Teabags/dp/B07DN8HVGS/",
    "page_count": 48,
    "reviews": 15,
    "ratings": 4.1,
    "image_count": 6,
    "product_name": "The Hillcart Tales Honey Limon Green Tea,(14 Teabags)",
    "item_id": "B07DN8HVGS",
    "brand": "the hillcart tales"
  },
  {
    "order": 96,
    "price": "",
    "offer": "Rs 300.00",
    "page": 2,
    "link": "https://www.amazon.in//Twinings-Green-Tea-Cranberry-Bags/dp/B07F885591/",
    "page_count": 48,
    "reviews": 18,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "Twinings Green Tea Cranberry, 25 Teabags, Green Tea, Zingy Sharpness of Cranberry with Golden Green Tea",
    "item_id": "B07F885591",
    "brand": "twinings"
  },
  {
    "order": 97,
    "price": "Rs 510.00",
    "offer": "Rs 999.00",
    "page": 3,
    "link": "https://www.amazon.in//Twinings-Matcha-Green-Cranberr-20Tea/dp/B079SVP764/",
    "page_count": 48,
    "reviews": 5,
    "ratings": 3.9,
    "image_count": 1,
    "product_name": "Twinings Matcha Green Tea with Cranberr & Lime 20Tea Bags.",
    "item_id": "B079SVP764",
    "brand": "twinings"
  },
  {
    "order": 98,
    "price": "",
    "offer": "Rs 275.00",
    "page": 3,
    "link": "https://www.amazon.in//Onlyleaf-Moringa-Green-Exotic-Samples/dp/B07QXVKQKD/",
    "page_count": 48,
    "reviews": 44,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "ONLYLEAF Moringa Green Tea for Healthy Heart, Made with 100% Whole Leaf, Natural Moringa & Ginger, 27 Pyramid Tea Bags (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07QXVKQKD",
    "brand": "onlyleaf"
  },
  {
    "order": 99,
    "price": "",
    "offer": "Rs 225.00",
    "page": 3,
    "link": "https://www.amazon.in//VAHDAM-Ingredients-Certified-Organic-Ayurvedic/dp/B08GG41KM7/",
    "page_count": 48,
    "reviews": 60,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "VAHDAM, Detox Kahwa Green Tea- 15 Tea Bags | Real Ingredients (Black Pepper, Tulsi, Ginger, Clove, and Green Tea), Certified Organic Ayurvedic Kahwa | 5-Day Detox",
    "item_id": "B08GG41KM7",
    "brand": "vahdam"
  },
  {
    "order": 100,
    "price": "Rs 150.00",
    "offer": "",
    "page": 3,
    "link": "https://www.amazon.in//Ripple-Strong-Green-Tea-250gm/dp/B08FB7ZDHF/",
    "page_count": 48,
    "reviews": 3,
    "ratings": 4.6,
    "image_count": 5,
    "product_name": "Ripple Strong Green Tea - 250gm",
    "item_id": "B08FB7ZDHF",
    "brand": "ripple"
  },
  {
    "order": 101,
    "price": "",
    "offer": "Rs 199.00",
    "page": 3,
    "link": "https://www.amazon.in//SPRIG-TE-Gtea-Oriental-Ginger/dp/B07WM5K56V/",
    "page_count": 48,
    "reviews": 17,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "SPRIG TE.A Green Tea with Oriental Ginger | Fully Soluble Green Tea | Rejuvenate The Body with Ginger & Green Tea with a hint of Lime | Immunity-Boosting Tea | Pack of 25",
    "item_id": "B07WM5K56V",
    "brand": "sprig te.a"
  },
  {
    "order": 102,
    "price": "",
    "offer": "Rs 196.00",
    "page": 3,
    "link": "https://www.amazon.in//Cambridge-Tea-Party-Lemongrass-Sticks/dp/B07WRD93ZJ/",
    "page_count": 48,
    "reviews": 22,
    "ratings": 4,
    "image_count": 6,
    "product_name": "Cambridge Tea Party Spa, Lemon Lime Lemongrass Green Tea, 40 Tea Bag Sticks",
    "item_id": "B07WRD93ZJ",
    "brand": "cambridge tea party"
  },
  {
    "order": 103,
    "price": "Rs 175.00",
    "offer": "",
    "page": 3,
    "link": "https://www.amazon.in//Eco-Valley-Organic-Green-Tulsi/dp/B00M4ZB0ZI/",
    "page_count": 48,
    "reviews": 87,
    "ratings": 4.1,
    "image_count": 6,
    "product_name": "Eco Valley Organic Green Tea, Divine Tulsi, 30 Tea Bags",
    "item_id": "B00M4ZB0ZI",
    "brand": "eco valley"
  },
  {
    "order": 104,
    "price": "",
    "offer": "Rs 225.00",
    "page": 3,
    "link": "https://www.amazon.in//Cambridge-Tea-Party-Assorted-Sticks/dp/B07WSCSHJC/",
    "page_count": 48,
    "reviews": 40,
    "ratings": 3.9,
    "image_count": 6,
    "product_name": "Cambridge Tea Party Mix, Assorted Tea, Immunity Booster, Cleanse Pure Light Green, Spa Lemon Lime Lemongrass, Calm Chamomile, Detox Kahwa, Slim Orange, Refresh Tulsi Mint, Sampler Pack, 36 Tea Bag Sticks",
    "item_id": "B07WSCSHJC",
    "brand": "cambridge tea party"
  },
  {
    "order": 105,
    "price": "Rs 333.00",
    "offer": "Rs 370.00",
    "page": 3,
    "link": "https://www.amazon.in//Nutrust-Probiotics-sachets-instant-probiotic/dp/B08C7F3DK1/",
    "page_count": 48,
    "reviews": 3,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Nutrust Green Tea with Probiotics Pack of 2 (20 + 20) sachets 2 gram each in instant sachet form earlier known as probiotic green tea nutrus",
    "item_id": "B08C7F3DK1",
    "brand": "nutrust"
  },
  {
    "order": 106,
    "price": "",
    "offer": "Rs 475.00",
    "page": 3,
    "link": "https://www.amazon.in//Blue-Nectar-Amritanadi-Leaves-Himalyan/dp/B079HP7BFZ/",
    "page_count": 48,
    "reviews": 183,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "Blue Nectar Amritanadi Assam Mogra Green Tea Leaves with Himalyan Rose (65 gm, 33 Cups)",
    "item_id": "B079HP7BFZ",
    "brand": "blue nectar"
  },
  {
    "order": 107,
    "price": "Rs 140.00",
    "offer": "Rs 148.00",
    "page": 3,
    "link": "https://www.amazon.in//Duncans-Double-Diamond-Tulsi-Green/dp/B08HQY2SDS/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 5,
    "image_count": 6,
    "product_name": "Duncans Double Diamond Tulsi Green Tea (Pack of 25 Tea Bags)",
    "item_id": "B08HQY2SDS",
    "brand": "duncans"
  },
  {
    "order": 108,
    "price": "Rs 249.00",
    "offer": "",
    "page": 3,
    "link": "https://www.amazon.in//Only-Green-Health-Teabags-Flavours/dp/B07PJYQBPY/",
    "page_count": 48,
    "reviews": 33,
    "ratings": 4.2,
    "image_count": 4,
    "product_name": "Onlyleaf Green Tea for Weight Loss Health Box (24 Teabags, 6 Flavours)",
    "item_id": "B07PJYQBPY",
    "brand": "onlyleaf"
  },
  {
    "order": 109,
    "price": "Rs 369.00",
    "offer": "Rs 399.00",
    "page": 3,
    "link": "https://www.amazon.in//LuvLungs-Organic-Smokers-Cleanse-Pollution/dp/B07NWDB7GV/",
    "page_count": 48,
    "reviews": 231,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "LuvLungs Organic Green Tea for Smokers Lungs Cleanse and Air Pollution Detox + Immunity Booster. 1 Pack of 20 Sachets. Natural and Handmade.",
    "item_id": "B07NWDB7GV",
    "brand": "luvlungs"
  },
  {
    "order": 110,
    "price": "Rs 325.00",
    "offer": "Rs 350.00",
    "page": 3,
    "link": "https://www.amazon.in//Indian-Chai-Slimming-Nitrogen-Freshness/dp/B071VSP2W1/",
    "page_count": 48,
    "reviews": 105,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "The Indian Chai - Rose Green Tea 100g | Natural Stress Buster | Supports Weight Loss | Nitrogen Filled, Vacuum Sealed for Freshness |",
    "item_id": "B071VSP2W1",
    "brand": "the indian chai"
  },
  {
    "order": 111,
    "price": "Rs 453.00",
    "offer": "Rs 500.00",
    "page": 3,
    "link": "https://www.amazon.in//Lipton-Pure-Light-Green-Pieces/dp/B01CHVOF2I/",
    "page_count": 48,
    "reviews": 75,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Lipton Pure & Light Green Tea Bags, 100 Pc",
    "item_id": "B01CHVOF2I",
    "brand": "lipton"
  },
  {
    "order": 112,
    "price": "",
    "offer": "Rs 196.00",
    "page": 3,
    "link": "https://www.amazon.in//Cambridge-Tea-Party-Indian-Sticks/dp/B07WNJNYQM/",
    "page_count": 48,
    "reviews": 85,
    "ratings": 3.4,
    "image_count": 6,
    "product_name": "Cambridge Tea Party Detox, Wild Indian Kahwa, Green Tea, Immunity Booster, 40 Tea Bag Sticks",
    "item_id": "B07WNJNYQM",
    "brand": "cambridge tea party"
  },
  {
    "order": 113,
    "price": "Rs 249.00",
    "offer": "Rs 349.00",
    "page": 3,
    "link": "https://www.amazon.in//SPRIG-TE-Soluble-Immunity-Boosting-Ingredients/dp/B08KQ4RJZ6/",
    "page_count": 48,
    "reviews": 10,
    "ratings": 4.9,
    "image_count": 7,
    "product_name": "SPRIG TE.A Tulsi and Ginger Combo | Fully Soluble Green Tea | Immunity-Boosting Range Made with Fresh, Tender Green Tea and Natural Ingredients | Packs of 25",
    "item_id": "B08KQ4RJZ6",
    "brand": "sprig te.a"
  },
  {
    "order": 114,
    "price": "Rs 385.00",
    "offer": "Rs 399.00",
    "page": 3,
    "link": "https://www.amazon.in//Real-Matcha-Japanese-Powder-Weight/dp/B07CWDQQ3V/",
    "page_count": 48,
    "reviews": 13,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "Real Matcha Japanese Matcha Green Tea Powder for Weight Loss 30gm (30 Cups)",
    "item_id": "B07CWDQQ3V",
    "brand": "real matcha"
  },
  {
    "order": 115,
    "price": "Rs 320.00",
    "offer": "Rs 400.00",
    "page": 3,
    "link": "https://www.amazon.in//Teamonk-Nilgiri-Jasmine-Natural-Additives/dp/B01LXQ3FEJ/",
    "page_count": 48,
    "reviews": 91,
    "ratings": 3.9,
    "image_count": 6,
    "product_name": "Teamonk Nilgiri Jasmine Green Tea for Weight Loss, (50 Cups) | 100% Natural Loose Leaf Tea with Natural Jasmine Buds | Koge Jasmine Green Tea for Weight Loss | No Additives, 100 g",
    "item_id": "B01LXQ3FEJ",
    "brand": "teamonk"
  },
  {
    "order": 116,
    "price": "Rs 354.00",
    "offer": "",
    "page": 3,
    "link": "https://www.amazon.in//Cambridge-Tea-Party-Sampler-Cleanse/dp/B08CXF9GM1/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 3.1,
    "image_count": 5,
    "product_name": "Cambridge Tea Party, Assorted Tea 60 Green Tea Bags Sampler Pack, Cleanse Pure Light Green, Spa Lemon Lime Lemongrass, Calm Chamomile, Detox Kahwa, Slim Orange, Refresh Tulsi Mint, 10 Tea Bags Each, 145 g",
    "item_id": "B08CXF9GM1",
    "brand": "cambridge tea party"
  },
  {
    "order": 117,
    "price": "",
    "offer": "Rs 250.00",
    "page": 3,
    "link": "https://www.amazon.in//Onlyleaf-Organic-Green-Exotic-Samples/dp/B07D9V6S9S/",
    "page_count": 48,
    "reviews": 178,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "ONLYLEAF Organic Green Tea for Weight Loss, Made with 100% Whole Leaf, Sourced from Highlands of Darjeeling, 27 Pyramid Tea Bags (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07D9V6S9S",
    "brand": "onlyleaf"
  },
  {
    "order": 118,
    "price": "Rs 389.00",
    "offer": "Rs 400.00",
    "page": 3,
    "link": "https://www.amazon.in//MAI-T-Weight-Nutmeg-Cardamom-Natural/dp/B086RMGX2T/",
    "page_count": 48,
    "reviews": 7,
    "ratings": 5,
    "image_count": 7,
    "product_name": "MAI-T Detox Whole Leaf Green Tea for Weight Loss with Clove, Nutmeg, Basil, Ginger, Cardamom & Black Pepper | 100% Natural & Pure | Net Qty - 50 Grams ( 25-30 Cups )",
    "item_id": "B086RMGX2T",
    "brand": "mai-t"
  },
  {
    "order": 119,
    "price": "Rs 118.00",
    "offer": "Rs 119.00",
    "page": 3,
    "link": "https://www.amazon.in//VAHDAM-Sampler-Assorted-Certified-Organic/dp/B08GG35QD4/",
    "page_count": 48,
    "reviews": 126,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "VAHDAM - Green Tea Sampler Trial Pack | 8 Assorted Green Tea Bags | USDA Certified Organic Green Tea",
    "item_id": "B08GG35QD4",
    "brand": "vahdam"
  },
  {
    "order": 120,
    "price": "Rs 349.00",
    "offer": "Rs 399.00",
    "page": 3,
    "link": "https://www.amazon.in//Chengmari-Green-Natural-Original-Handpicked/dp/B07WS15JZ1/",
    "page_count": 48,
    "reviews": 109,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Chengmari Green Tea, Natural, Original and Handpicked Long Leaf Green Tea, 250 gm (125 Cups)",
    "item_id": "B07WS15JZ1",
    "brand": "chengmari"
  },
  {
    "order": 121,
    "price": "Rs 157.50",
    "offer": "Rs 225.00",
    "page": 3,
    "link": "https://www.amazon.in//Vahdam-Organic-Green-Tea-Bags/dp/B083V4DCK4/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 1,
    "product_name": "Vahdam Organic Green Tea Bags - 15 Count, 30 g",
    "item_id": "B083V4DCK4",
    "brand": "vahdam"
  },
  {
    "order": 122,
    "price": "",
    "offer": "Rs 275.00",
    "page": 3,
    "link": "https://www.amazon.in//Onlyleaf-Tulsi-Green-Exotic-Samples/dp/B07D9V8867/",
    "page_count": 48,
    "reviews": 130,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "ONLYLEAF Tulsi Green Tea for Cold Relief, Made with 100% Whole Leaf & Natural Tulsi (Holy Basil), 27 Pyramid Tea Bags (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07D9V8867",
    "brand": "onlyleaf"
  },
  {
    "order": 123,
    "price": "",
    "offer": "",
    "page": 3,
    "link": "https://www.amazon.in//Lipton-After-Lunch-Green-Bags/dp/B07VP33FD3/",
    "page_count": 48,
    "reviews": 22,
    "ratings": 4.1,
    "image_count": 6,
    "product_name": "Lipton After Lunch Green Tea Bags, 25 Pcs",
    "item_id": "B07VP33FD3",
    "brand": "lipton"
  },
  {
    "order": 124,
    "price": "Rs 396.00",
    "offer": "Rs 440.00",
    "page": 3,
    "link": "https://www.amazon.in//Care-Ashwagandha-Spiced-Green-Tea/dp/B08HNC1567/",
    "page_count": 48,
    "reviews": 4,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "Care Ashwagandha Spiced Green Tea - 25 Tea Bags + Care Moringa & Giloy Green Tea with Lemongrass - 20 Tea Bags",
    "item_id": "B08HNC1567",
    "brand": "care"
  },
  {
    "order": 125,
    "price": "",
    "offer": "Rs 910.00",
    "page": 3,
    "link": "https://www.amazon.in//Twinings-Green-Tea-Lemon-Honey/dp/B0774SZGCW/",
    "page_count": 48,
    "reviews": 26,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Twinings Green Tea Lemon & Honey, 100 Teabags, Green Tea, Sweet Honey & Tangy Lemon",
    "item_id": "B0774SZGCW",
    "brand": "twinings"
  },
  {
    "order": 126,
    "price": "",
    "offer": "",
    "page": 3,
    "link": "https://www.amazon.in//Leefords-Green-Lemon-Refreshing-Flavour/dp/B08F3GRRQW/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 4,
    "product_name": "Click to open expanded viewLeeford's Green Tea Lemon With Honey Refreshing Flavour (25 Bags Each) Pack of 2",
    "item_id": "",
    "brand": ""
  },
  {
    "order": 127,
    "price": "Rs 164.00",
    "offer": "Rs 174.00",
    "page": 3,
    "link": "https://www.amazon.in//Organic-India-Tulsi-Green-Jasmine/dp/B077VQDT9W/",
    "page_count": 48,
    "reviews": 82,
    "ratings": 4.3,
    "image_count": 5,
    "product_name": "Organic India Tulsi Green Tea, Jasmine, 25 Tea Bags",
    "item_id": "B077VQDT9W",
    "brand": "organic india"
  },
  {
    "order": 128,
    "price": "",
    "offer": "Rs 349.00",
    "page": 3,
    "link": "https://www.amazon.in//TGL-Mogo-Green-Exotic-Sample/dp/B07S4BPRCL/",
    "page_count": 48,
    "reviews": 18,
    "ratings": 4.6,
    "image_count": 7,
    "product_name": "TGL Mogo Mogo Green Tea, 16 Tea Bags (15 Tea Bags + 1 Free Exotic Sample)",
    "item_id": "B07S4BPRCL",
    "brand": "tgl co. luxury teas"
  },
  {
    "order": 129,
    "price": "Rs 721.00",
    "offer": "Rs 910.00",
    "page": 3,
    "link": "https://www.amazon.in//Twinings-Green-Tea-Lemon-Bags/dp/B00L941ZUA/",
    "page_count": 48,
    "reviews": 145,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Twinings Green Tea & Lemon, 100 Teabags, Green Tea, Deliciously Sweet & Tangy Lemon",
    "item_id": "B00L941ZUA",
    "brand": "twinings"
  },
  {
    "order": 130,
    "price": "",
    "offer": "Rs 196.00",
    "page": 3,
    "link": "https://www.amazon.in//Cambridge-Tea-Party-Orange-Berries/dp/B07WSD13X9/",
    "page_count": 48,
    "reviews": 21,
    "ratings": 3.4,
    "image_count": 6,
    "product_name": "Cambridge Tea Party Slim, Orange Berries Green Tea, 40 Tea Bag Sticks",
    "item_id": "B07WSD13X9",
    "brand": "cambridge tea party"
  },
  {
    "order": 131,
    "price": "Rs 146.00",
    "offer": "Rs 210.00",
    "page": 3,
    "link": "https://www.amazon.in//Typhoo-Green-Moroccan-Mint-Bags/dp/B00LRHACEY/",
    "page_count": 48,
    "reviews": 110,
    "ratings": 4.2,
    "image_count": 2,
    "product_name": "Typhoo Organic Green Tea - Moroccan Mint, 25 Bags",
    "item_id": "B00LRHACEY",
    "brand": "typhoo"
  },
  {
    "order": 132,
    "price": "Rs 175.00",
    "offer": "Rs 184.00",
    "page": 3,
    "link": "https://www.amazon.in//Organic-India-Tulsi-Green-Assorted/dp/B07LFDGDLG/",
    "page_count": 48,
    "reviews": 33,
    "ratings": 4.4,
    "image_count": 3,
    "product_name": "Organic India Tulsi Green Tea Assorted 25 Tea Bags",
    "item_id": "B07LFDGDLG",
    "brand": "organic india"
  },
  {
    "order": 133,
    "price": "",
    "offer": "",
    "page": 3,
    "link": "https://www.amazon.in//Nutrust-Probiotic-Green-earlier-Nutrus/dp/B07WF189B3/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 5,
    "product_name": "Nutrust Probiotic Green Tea, 20 Sachets (Pack of 3)",
    "item_id": "",
    "brand": ""
  },
  {
    "order": 134,
    "price": "Rs 280.00",
    "offer": "Rs 400.00",
    "page": 3,
    "link": "https://www.amazon.in//Teamonk-Nilgiri-Orange-Natural-Additives/dp/B071F2X4NT/",
    "page_count": 48,
    "reviews": 52,
    "ratings": 4.1,
    "image_count": 6,
    "product_name": "Teamonk Nilgiri Orange Detox Green Tea for Weight Loss, 100g (50 Cups) | 100% Natural Loose Leaf Tea with Natural Orange Zest | Sozen Green Tea for Weight Loss | Fruit Tea | No Additives",
    "item_id": "B071F2X4NT",
    "brand": "teamonk"
  },
  {
    "order": 135,
    "price": "Rs 875.00",
    "offer": "Rs 900.00",
    "page": 3,
    "link": "https://www.amazon.in//APSARA-Immunity-Boosting-Properties-Antioxidants/dp/B08FRH9L6C/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 5,
    "image_count": 6,
    "product_name": "APSARA Detox Kahwa Green Tea | Immunity Boosting Properties | Antioxidants Properties | 100 Tea Bag",
    "item_id": "B08FRH9L6C",
    "brand": "apsara"
  },
  {
    "order": 136,
    "price": "",
    "offer": "Rs 300.00",
    "page": 3,
    "link": "https://www.amazon.in//Twinings-Green-Tea-Cranberry-Bags/dp/B07F885591/",
    "page_count": 48,
    "reviews": 18,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "Twinings Green Tea Cranberry, 25 Teabags, Green Tea, Zingy Sharpness of Cranberry with Golden Green Tea",
    "item_id": "B07F885591",
    "brand": "twinings"
  },
  {
    "order": 137,
    "price": "",
    "offer": "Rs 499.00",
    "page": 3,
    "link": "https://www.amazon.in//Treelicious-Kashmiri-Saffron-Indian-Spices/dp/B08GQ7VK53/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 5,
    "product_name": "Treelicious - Royal Kashmiri Kahwa Tea with Saffron and Indian Spices | Detox Green Tea (100 gm)",
    "item_id": "B08GQ7VK53",
    "brand": "treelicious"
  },
  {
    "order": 138,
    "price": "Rs 299.00",
    "offer": "Rs 349.00",
    "page": 3,
    "link": "https://www.amazon.in//Udyan-Tea-Moroccan-Mint-Green/dp/B08NCGKMJH/",
    "page_count": 48,
    "reviews": 52,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Udyan Tea Moroccan Mint Green Tea - 50g (20 Cups) | Pure, Refreshing Green Tea Blend with Spearmint Leaves",
    "item_id": "B08NCGKMJH",
    "brand": "udyan tea"
  },
  {
    "order": 139,
    "price": "Rs 155.00",
    "offer": "Rs 220.00",
    "page": 3,
    "link": "https://www.amazon.in//Nikunj-Green-Tea-250g-Extra/dp/B07V3W9P94/",
    "page_count": 48,
    "reviews": 110,
    "ratings": 3.8,
    "image_count": 3,
    "product_name": "Nikunj Premium Green Tea Jar, 250 g with Super Saver Pack",
    "item_id": "B07V3W9P94",
    "brand": "nikunj"
  },
  {
    "order": 140,
    "price": "",
    "offer": "Rs 999.00",
    "page": 3,
    "link": "https://www.amazon.in//BLUE-TEA-Combo-Lavender-Shankhpushpi/dp/B08P52ZMZY/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 2,
    "image_count": 7,
    "product_name": "BLUE TEA -Combo - Rose Green Tea (100 Gram) & Lavender Green Tea | Whole Leaf with Shankhpushpi | 200 Gram",
    "item_id": "B08P52ZMZY",
    "brand": "blue tea"
  },
  {
    "order": 141,
    "price": "",
    "offer": "Rs 275.00",
    "page": 3,
    "link": "https://www.amazon.in//Onlyleaf-Turmeric-Ginger-Exotic-Samples/dp/B07D9TB5JG/",
    "page_count": 48,
    "reviews": 222,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "ONLYLEAF Turmeric Ginger Tulsi Green Tea For Immunity Boosting & Sore Throat Prevention, Made with 100% Whole Leaf, Natural Ginger, Turmeric & Tulsi,27 Pyramid Tea Bags (25 Tea Bags + 2 Free Samples)",
    "item_id": "B07D9TB5JG",
    "brand": "onlyleaf"
  },
  {
    "order": 142,
    "price": "",
    "offer": "Rs 260.00",
    "page": 3,
    "link": "https://www.amazon.in//Octavius-Pure-Green-Tea-Teabags/dp/B081VJF48J/",
    "page_count": 48,
    "reviews": 72,
    "ratings": 3.9,
    "image_count": 7,
    "product_name": "Octavius Pure Green Tea - 100 Teabags",
    "item_id": "B081VJF48J",
    "brand": "octavius"
  },
  {
    "order": 143,
    "price": "Rs 348.00",
    "offer": "",
    "page": 3,
    "link": "https://www.amazon.in//Organic-India-Tulsi-Ginger-Pomegranate/dp/B081ZXH2GV/",
    "page_count": 48,
    "reviews": 5,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "Organic India Tulsi Green Tea, (Lemon Ginger + Pomegranate)",
    "item_id": "B081ZXH2GV",
    "brand": "organic india"
  },
  {
    "order": 144,
    "price": "",
    "offer": "Rs 300.00",
    "page": 3,
    "link": "https://www.amazon.in//Twinings-Green-Tea-Apple-Bags/dp/B07F873VYR/",
    "page_count": 48,
    "reviews": 15,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "Twinings Green Tea Green Apple, 25 Teabags, Green Tea, Pure, Fruity & Indulgent",
    "item_id": "B07F873VYR",
    "brand": "twinings"
  }
] 
        for (let [idx, ds] of  resData.entries())
        {
          self.rows_details.push(ds)
          self.rows_details_full.push(ds)
        }
        self.loader = false
        self.$nextTick(function(){
          self.initDt2()
        })  
      
      }, err => {
        self.loader = false
        console.log(err)
        console.log('err')
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
    },
    initDt2(){
      let self = this
      $('#myTable2').DataTable({
        initComplete: function () {
          this.api().columns().every( function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                  .appendTo( $(column.footer()).empty() )
                  .on( 'change', function () {
                      var val = $.fn.dataTable.util.escapeRegex(
                          $(this).val()
                      );    
                      column
                          .search( val ? '^'+val+'$' : '', true, false )
                          .draw();
                  } );
              let arr = []    
              let sortedArr = []
              column.data().unique().sort().each( function ( d, j ) {
                var myVal = $(d).text()
                arr.push(myVal)
              } ); 
                
              sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true}))
              for (let [idx, ds] of sortedArr.entries())
              {
                select.append( "<option value='"+ds+"'>"+ds+"</option>" )
              } 
          } );
        }
      });
    }
  }
}

</script>

<style scoped>

.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:999
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
</style>
